import { render, staticRenderFns } from "./SectionEdit.vue?vue&type=template&id=05c78d5c"
import script from "./SectionEdit.vue?vue&type=script&lang=js"
export * from "./SectionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports